import "./index.scss";

const ToggleButton = () => {
  return (
    <button
      type="button"
      data-state="closed"
      class="header-toggle-button"
      data-action="handleToggleMenus"
    >
      <svg
        class="header-toggle-button__icon"
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        width="18px"
        height="18px"
      >
        <line
          class="header-toggle-button__icon-line"
          x1="0"
          y1="20"
          x2="100"
          y2="20"
          stroke="black"
          stroke-width="6"
        />
        <line
          class="header-toggle-button__icon-line"
          x1="0"
          y1="50"
          x2="100"
          y2="50"
          stroke="black"
          stroke-width="6"
        />
        <line
          class="header-toggle-button__icon-line"
          x1="0"
          y1="80"
          x2="100"
          y2="80"
          stroke="black"
          stroke-width="6"
        />
      </svg>
    </button>
  );
}

export default ToggleButton;
